import { Link } from 'react-router-dom';
import Layout from '../../components/base/Layout';
import { products } from '../../mocks/products';

export default function HomePage() {
  const featuredProducts = products.slice(0, 6);

  const stats = [
    { value: '25+', label: 'Years Experience', icon: 'ri-calendar-line' },
    { value: '500+', label: 'Tons Exported', icon: 'ri-truck-line' },
    { value: '35+', label: 'Countries', icon: 'ri-global-line' },
    { value: '99.8%', label: 'Quality Rate', icon: 'ri-shield-check-line' }
  ];

  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative h-screen min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20lush%20green%20Egyptian%20agricultural%20fields%20with%20golden%20sunlight%20streaming%20through%20clouds%20beautiful%20farmland%20landscape%20professional%20drone%20photography%20vibrant%20colors%20morning%20mist&width=1920&height=1080&seq=500&orientation=landscape"
            alt="Egyptian Agricultural Fields"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-1/4 left-10 w-20 h-20 bg-emerald-500/20 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-1/3 right-10 w-32 h-32 bg-teal-500/20 rounded-full blur-xl animate-pulse delay-1000"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-5xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full mb-6 md:mb-8 border border-white/20">
            <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></span>
            <span className="text-white/90 text-xs md:text-sm font-medium">
              Premium Egyptian Agricultural Exports
            </span>
          </div>

          <h1 className="text-3xl sm:text-5xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
            From Egypt&apos;s Finest
            <span className="block bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Fields to Your Market</span>
          </h1>

          <p className="text-sm sm:text-lg lg:text-xl text-white/80 max-w-2xl mx-auto mb-8 md:mb-10 px-4">
            Al-Amein delivers premium fresh fruits, vegetables, and legumes to global markets with
            25+ years of excellence in quality and service.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/products"
              className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 text-white text-sm md:text-base font-semibold rounded-full flex items-center justify-center gap-2 whitespace-nowrap relative overflow-hidden group"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_100%] animate-gradient-move"></span>
              <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
              <span className="relative z-10 flex items-center gap-2">
                Explore Products
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
            <Link
              to="/contact"
              className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-white/10 backdrop-blur-md text-white text-sm md:text-base font-semibold rounded-full border border-white/30 hover:bg-white/20 transition-all duration-300 whitespace-nowrap text-center"
            >
              Get a Quote
            </Link>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-6 md:bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/60 text-xs uppercase tracking-widest">Scroll</span>
          <i className="ri-arrow-down-line text-white/60 text-xl"></i>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="relative -mt-12 md:-mt-16 z-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white/80 backdrop-blur-xl rounded-2xl md:rounded-3xl shadow-2xl p-4 md:p-8 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 border border-white/20">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl md:rounded-2xl mx-auto mb-2 md:mb-4 relative overflow-hidden group cursor-pointer">
                  <span className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_100%] animate-gradient-move"></span>
                  <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <i className={`${stat.icon} text-xl md:text-2xl text-white relative z-10`}></i>
                </div>
                <div className="text-xl md:text-3xl font-bold text-gray-900">{stat.value}</div>
                <div className="text-xs md:text-sm text-gray-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
            <div className="relative order-2 lg:order-1">
              <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="/logo/ALAMIN.jpg"
                  alt="Al-Amein Products"
                  className="w-full h-auto object-cover"
                />
              </div>
              {/* Floating Card */}
              <div className="absolute -bottom-4 -right-4 md:-bottom-8 md:-right-8 rounded-2xl md:rounded-3xl p-4 md:p-6 shadow-2xl hidden sm:block relative overflow-hidden">
                <span className="absolute inset-0 bg-gradient-to-br from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_200%] animate-gradient-move"></span>
                <div className="flex items-center gap-3 md:gap-4 relative z-10">
                  <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-white/20 rounded-xl md:rounded-2xl">
                    <i className="ri-award-line text-2xl md:text-3xl text-white"></i>
                  </div>
                  <div className="text-white">
                    <div className="text-xl md:text-2xl font-bold">25+</div>
                    <div className="text-xs md:text-sm text-white/80">Years of Excellence</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-4 md:space-y-6 order-1 lg:order-2">
              <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-600 text-xs md:text-sm font-semibold rounded-full">
                About Al-Amein
              </span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
                Egypt&apos;s Premier{' '}
                <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Agricultural</span> Export Company
              </h2>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Al-Amein emerges as a leading import and export firm, solely dedicated to
                spearheading the international distribution of Egypt&apos;s finest fresh fruits and
                vegetables. Our unwavering commitment to food safety is demonstrably etched in
                our coveted standing on the National Food Safety Whitelist.
              </p>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                As a distinguished member of the Egyptian Export Council, we actively champion
                the export of Egyptian agricultural produce, showcasing its excellence on the
                world stage.
              </p>
              <div className="flex flex-wrap gap-3 md:gap-4 pt-2 md:pt-4">
                <div className="flex items-center gap-2 text-xs md:text-sm text-gray-600">
                  <i className="ri-check-double-line text-emerald-500"></i>
                  Global GAP Certified
                </div>
                <div className="flex items-center gap-2 text-xs md:text-sm text-gray-600">
                  <i className="ri-check-double-line text-emerald-500"></i>
                  ISO 22000:2018
                </div>
                <div className="flex items-center gap-2 text-xs md:text-sm text-gray-600">
                  <i className="ri-check-double-line text-emerald-500"></i>
                  HACCP Certified
                </div>
              </div>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-5 md:px-6 py-2.5 md:py-3 bg-gray-900 text-white text-xs md:text-sm font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 whitespace-nowrap"
              >
                Learn More About Us
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 md:mb-16">
            <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-600 text-xs md:text-sm font-semibold rounded-full mb-3 md:mb-4">
              Our Products
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
              Premium <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Egyptian Produce</span>
            </h2>
            <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
              Discover our extensive range of fresh fruits, vegetables, and legumes, carefully
              cultivated and prepared for international markets.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-product-shop>
            {featuredProducts.map((product) => (
              <Link
                key={product.id}
                to={`/product/${product.id}`}
                className="group relative bg-white rounded-2xl md:rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
              >
                <div className="relative h-56 md:h-72 w-full overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                  <span className="absolute top-3 md:top-4 left-3 md:left-4 px-2.5 md:px-3 py-1 bg-white/90 backdrop-blur-sm text-emerald-600 text-xs font-semibold rounded-full">
                    {product.category}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                  <h3 className="text-lg md:text-xl font-bold text-white mb-1 md:mb-2">{product.name}</h3>
                  <div className="flex items-center justify-between">
                    <span className="text-white/70 text-xs md:text-sm">{product.specifications.season}</span>
                    <span className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full relative overflow-hidden group/btn">
                      <span className="absolute inset-0 bg-white/20 backdrop-blur-sm"></span>
                      <span className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_100%] animate-gradient-move opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                      <i className="ri-arrow-right-line text-white relative z-10"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-8 md:mt-12">
            <Link
              to="/products"
              className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-4 text-white text-sm md:text-base font-semibold rounded-full relative overflow-hidden group whitespace-nowrap"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_100%] animate-gradient-move"></span>
              <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
              <span className="relative z-10 flex items-center gap-2">
                View All Products
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
            <div className="space-y-4 md:space-y-6">
              <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-600 text-xs md:text-sm font-semibold rounded-full">
                Why Choose Us
              </span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
                Your Trusted Partner for{' '}
                <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Quality Exports</span>
              </h2>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                With decades of experience and a commitment to excellence, Al-Amein ensures every
                shipment meets the highest international standards.
              </p>

              <div className="space-y-4 md:space-y-6 pt-2 md:pt-4">
                {[
                  {
                    icon: 'ri-shield-check-line',
                    title: 'Quality Guaranteed',
                    desc: 'Rigorous quality control at every stage'
                  },
                  {
                    icon: 'ri-truck-line',
                    title: 'Global Logistics',
                    desc: 'Efficient cold chain to 35+ countries'
                  },
                  {
                    icon: 'ri-customer-service-2-line',
                    title: '24/7 Support',
                    desc: 'Dedicated team for all your inquiries'
                  },
                  {
                    icon: 'ri-price-tag-3-line',
                    title: 'Competitive Pricing',
                    desc: 'Best value for premium quality produce'
                  }
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-3 md:gap-4 group">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl md:rounded-2xl flex-shrink-0 relative overflow-hidden cursor-pointer">
                      <span className="absolute inset-0 bg-emerald-100 group-hover:opacity-0 transition-opacity duration-300"></span>
                      <span className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_100%] animate-gradient-move opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                      <i
                        className={`${item.icon} text-xl md:text-2xl text-emerald-600 group-hover:text-white transition-colors duration-300 relative z-10`}
                      ></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-0.5 md:mb-1 text-sm md:text-base">{item.title}</h3>
                      <p className="text-gray-600 text-xs md:text-sm">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20agricultural%20export%20facility%20with%20workers%20carefully%20packing%20fresh%20fruits%20and%20vegetables%20in%20cartons%20professional%20photography%20clean%20environment%20quality%20control%20process&width=600&height=700&seq=501&orientation=portrait"
                alt="Quality Control"
                className="w-full h-auto rounded-2xl md:rounded-3xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 relative overflow-hidden">
        {/* Animated Background */}
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-600 bg-[length:200%_100%] animate-gradient-move"></div>
        
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 md:w-96 h-64 md:h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-64 md:w-96 h-64 md:h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
            Ready to Source Premium Egyptian Produce?
          </h2>
          <p className="text-sm md:text-lg text-white/80 mb-8 md:mb-10 max-w-2xl mx-auto">
            Our export team is available 24/7 to discuss your requirements and provide competitive
            quotes.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/contact"
              className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-white text-emerald-600 text-sm md:text-base font-semibold rounded-full hover:shadow-xl transition-all duration-300 whitespace-nowrap text-center"
            >
              Request a Quote
            </Link>
            <a
              href="https://wa.link/642z3y"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-transparent text-white text-sm md:text-base font-semibold rounded-full border-2 border-white/50 hover:bg-white/10 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg md:text-xl"></i>
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
